import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import * as Progress from "react-native-progress";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import Colors from "@microdoing/shared/constants/Colors";
import i18n from "@microdoing/shared/i18n";
import theme from "app/Theme/Theme";

const PollBar = ({ percentage, title, isUserChoice, hasVoted, onPress }) => {
  return (
    <TouchableOpacity disabled={hasVoted} style={styles.main} onPress={onPress}>
      <Progress.Bar
        progress={hasVoted ? percentage : 0}
        width={wp("100%") - 40}
        height={50}
        borderRadius={8}
        useNativeDriver
        borderWidth={hasVoted ? 0 : 1}
        borderColor={theme.colors["neutral.400"]}
        color={Colors.veryLightMain}
        unfilledColor={Colors.veryLightGrey}
      >
        <View
          style={[
            styles.titleView,
            isUserChoice && {
              borderLeftColor: theme.colors["brand.500"],
              borderLeftWidth: 5,
            },
          ]}
        >
          <Text style={styles.title}>{title}</Text>
        </View>
      </Progress.Bar>
      {hasVoted && (
        <Text style={[styles.percentage]}>
          {`${(percentage * 100).toFixed(0)}% ${i18n.t("people-voted")}`}
        </Text>
      )}
    </TouchableOpacity>
  );
};

const styles = {
  main: {
    marginTop: 20,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  titleView: {
    height: 50,
    paddingLeft: 20,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: wp("4.5%"),
    fontWeight: "bold",
    color: theme.colors["neutral.900"],
    textAlign: "left",
  },
  percentage: {
    width: wp("100%") - 40,
    marginTop: 5,
    marginLeft: 1,
    color: theme.colors["neutral.400"],
    fontSize: wp("3.5%"),
    textAlign: "left",
  },
  emptyBar: {},
  filledBar: {},
};

export default PollBar;
